<template>
	<div class="knd-toggle-container">
		<div class="knd-toggle">
			<div 
				ref="links" 
				class="knd-optie links"
				:class="{active: !toggleVal}"
					>
				<slot name="links"></slot>
			</div> 

			<div 
				class="knd-toggle-button" 
				@click="toggle">

				<div 
					ref="highlight"
					class="knd-toggle-highlight" 
					:class="{'left': !toggleVal, 'right': toggleVal}" 
					:style='{ backgroundColor: getButtonColor()}'></div>
			</div>

			<div 
				ref="rechts" 
				class="knd-optie rechts"
				:class="{active: toggleVal}"	
			>
				<slot name="rechts"></slot>
			</div>
		</div>
	</div>
</template>

<script>

	export default {
		name: 'Toggle',
		props: {
			value: {
				type: Boolean,
				default: false
			},
			colorLinks: {
				type: String,
				default: '#4E243F'
			},
			colorRechts: {
				type: String,
				default: '#4E243F'
			},
			toggleFn:Function
		},
		watch: {
			value: function(newValue) {
			this.toggleVal = newValue;
		}

	},	
		components: {},
		data() {
			return {
				toggleVal: this.value
			};
		},
		
		mounted: function() {},
		methods: {
			toggle() {
				this.toggleVal = !this.toggleVal;

				this.toggleFn();
			},

			getButtonColor() {
				return !this.toggleVal ? this.colorLinks : this.colorRechts;
			}
		}
	}
</script>

<style lang="scss">
.knd-toggle {
	position: relative;
	font-family: $font-body !important;
	display: flex;
	align-items: center;
	
	.knd-optie {
		position: relative;
		font-weight: 300;

		&.active {
			font-weight: 500;
			color: #4d00ff;
			// text-decoration: underline;
		}

		&.links {
			margin: 5px 10px 0 0;
		}

		&.rechts {
			margin: 5px 0 0 10px;
		}
	}

	.knd-toggle-button {
		position: relative;
		width: 80px;
		height: 40px;
		border-radius: 20px;
		border-width: 1px;
		border-style: solid;
		cursor: pointer;
		
		.knd-toggle-highlight {
			width: 34px;
			height: 34px;
			border-radius: 23px;
			position: absolute;
			top: 2px;
			left: 2px;
			border: 1px solid #4e243F;
			
			&.right {
				animation-name: toRight;
				animation-duration: .2s;
				animation-timing-function: ease;
				left: 42px;
			}

			&.left {
				animation-name: toLeft;
				animation-duration: .2s;
				animation-timing-function: ease;
				left: 2px;
			}

			@keyframes toRight {
				from {
					left: 2px;
				}

				to {
					left: 42px;
				}
			}

			@keyframes toLeft {
				from {
					left: 42px;
				}

				to {
					left: 2px;
				}
			}
		}
	}
}

</style>